import { FunctionComponent, ReactNode, Ref } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, mobileAndTabletCSS } from '@measures/responsive'
import Blink from '@components/Blink'

import { ListItemTeaserAPIProps } from './types'

type TeaserWrapperProps = {
  clickableProps: ListItemTeaserAPIProps['link']
  hideLastBorder?: boolean
  children?: ReactNode
  ref?: Ref<HTMLAnchorElement>
}

const BlinkWrapper = styled(Blink)<Pick<TeaserWrapperProps, 'hideLastBorder'>>`
  ${({
    theme: {
      spacing: { spacing16, spacing24, spacing32 },
      colors: { strokeWeak },
    },
    hideLastBorder,
  }) => css`
    position: relative;
    text-decoration: none;
    overflow: hidden;
    display: grid;
    border-bottom: 1px solid ${strokeWeak};

    ${desktopCSS(css`
      grid-template-columns: minmax(0, 1fr) 300px;
      grid-column-gap: ${spacing32};
      padding-bottom: ${spacing24};
    `)}

    ${mobileAndTabletCSS(css`
      grid-template-columns: minmax(0, 1fr) 171px;
      grid-column-gap: ${spacing16};
      padding-bottom: ${spacing16};
    `)};

    ${hideLastBorder &&
    css`
      &:last-child,
      &:nth-child(3) {
        border-bottom: 0;
      }
    `}
  `}
`

const TeaserWrapper: FunctionComponent<TeaserWrapperProps> = ({
  children,
  clickableProps,
  hideLastBorder,
  ref = null,
}) => (
  <BlinkWrapper {...clickableProps} hideLastBorder={hideLastBorder} ref={ref}>
    {children}
  </BlinkWrapper>
)

export default TeaserWrapper
